<template>
  <section>
    <el-date-picker
      v-model="dateRange"
      :clearable="false"
      type="daterange"
      class="fixed_date_picker"
      range-separator="至"
      start-placeholder="開始日期"
      end-placeholder="結束日期"
    />
    <div class="mt-3">
      <b-card>
        <div class="d-flex justify-content-end">
          <download-excel
            class="btn btn-primary mb-1"
            :name="`月結財務分析-${date_from}-${date_to}.xls`"
            :fields="monthlySalesFields"
            :data="monthlySalesTableData"
          >
            導出Excel
          </download-excel>
        </div>
        <apexchart
          v-if="isInit"
          type="line"
          height="350"
          :options="monthlySalesOptions"
          :series="monthly_sales"
          :key="'Monthly' + chartKey"
        ></apexchart>

        <b-table
          ref="refMonthlyTable"
          class="position-relative mt-2"
          :items="monthlySalesTableData"
          responsive
          :fields="monthlySalesTableColumns"
          show-empty
          empty-text="未找到匹配的記錄"
        >
          <!-- Column: Date -->
          <template #cell(Date)="data">
            {{ data.item.year }}年{{ data.item.month }}月
          </template>
        </b-table>

        <div class="mx-2 mt-1 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ monthlyDataMeta.of }}個記錄中，正在顯示
                {{ monthlyDataMeta.from }} 至
                {{ monthlyDataMeta.to }}個記錄</span
              >
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="monthlyCurrentPage"
                :total-rows="totalMonthly"
                :per-page="monthlyPerPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>

    <div class="mt-3">
      <b-card>
        <div class="d-flex justify-content-end">
          <download-excel
            class="btn btn-primary mb-1"
            :name="`日結財務分析-${date_from}-${date_to}.xls`"
            :fields="dailySalesFields"
            :data="dailySalesTableData"
          >
            導出Excel
          </download-excel>
        </div>
        <apexchart
          v-if="isInit"
          type="line"
          height="350"
          :options="dailySalesOptions"
          :series="daily_sales"
          :key="'Daily' + chartKey"
        ></apexchart>

        <b-table
          ref="refDailyTable"
          class="position-relative mt-2"
          :items="dailySalesTableData"
          responsive
          :fields="dailySalesTableColumns"
          show-empty
          empty-text="未找到匹配的記錄"
        >
        </b-table>

        <div class="mx-2 mt-1 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dailyDataMeta.of }}個記錄中，正在顯示
                {{ dailyDataMeta.from }} 至 {{ dailyDataMeta.to }}個記錄</span
              >
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="dailyCurrentPage"
                :total-rows="totalDaily"
                :per-page="dailyPerPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>

    <div class="mt-3">
      <b-card>
        <div class="d-flex justify-content-end">
          <download-excel
            class="btn btn-primary mb-1"
            :name="`服務及產品分析-${date_from}-${date_to}.xls`"
            :fields="categorySalesFields"
            :data="categorySalesTableData"
          >
            導出Excel
          </download-excel>
        </div>
        <apexchart
          v-if="isInit"
          type="bar"
          height="350"
          :options="categorySalesOptions"
          :series="category_sales"
          :key="'Category' + chartKey"
        ></apexchart>
        <b-table
          ref="refCategoryTable"
          class="position-relative mt-2"
          :items="categorySalesTableData"
          responsive
          :fields="categorySalesTableColumns"
          show-empty
          empty-text="未找到匹配的記錄"
        >
          <!-- Column: Date -->
          <template #cell(Date)="data">
            {{ data.item.year }}年{{ data.item.month }}月
          </template>
        </b-table>
        <div class="mx-2 mt-1 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ categoryDataMeta.of }}個記錄中，正在顯示
                {{ categoryDataMeta.from }} 至
                {{ categoryDataMeta.to }}個記錄</span
              >
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="categoryCurrentPage"
                :total-rows="totalCategory"
                :per-page="categoryPerPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>

    <div class="mt-3">
      <b-card>
        <div class="d-flex justify-content-end">
          <download-excel
            class="btn btn-primary mb-1"
            :name="`會員紀錄分析-${date_from}-${date_to}.xls`"
            :fields="customerSalesFields"
            :data="customerSalesTableData"
          >
            導出Excel
          </download-excel>
        </div>
        <apexchart
          v-if="isInit"
          type="bar"
          height="350"
          :options="customerSalesOptions"
          :series="customer_sales"
          :key="'Customer' + chartKey"
        ></apexchart>

        <b-table
          ref="refCustomerTable"
          class="position-relative mt-2"
          :items="customerSalesTableData"
          responsive
          :fields="customerSalesTableColumns"
          show-empty
          empty-text="未找到匹配的記錄"
        >
          <!-- Column: Date -->
          <template #cell(Date)="data">
            {{ data.item.year }}年{{ data.item.month }}月
          </template>
        </b-table>
        <div class="mx-2 mt-1 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ customerDataMeta.of }}個記錄中，正在顯示
                {{ customerDataMeta.from }} 至
                {{ customerDataMeta.to }}個記錄</span
              >
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="customerCurrentPage"
                :total-rows="totalCustomer"
                :per-page="customerPerPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>

    <div class="mt-3">
      <b-card>
        <div class="d-flex justify-content-end">
          <download-excel
            class="btn btn-primary mb-1"
            :name="`客戶數增長分析 -${date_from}-${date_to}.xls`"
            :fields="customerGrowthFields"
            :data="customerGrowthTableData"
          >
            導出Excel
          </download-excel>
        </div>
        <apexchart
          v-if="isInit"
          type="line"
          height="350"
          :options="customerGrowthOptions"
          :series="customer_growth"
          :key="'customerGrowth' + chartKey"
        ></apexchart>

        <b-table
          ref="refCustomerGrowthTable"
          class="position-relative mt-2"
          :items="customerGrowthTableData"
          responsive
          :fields="customerGrowthTableColumns"
          show-empty
          empty-text="未找到匹配的記錄"
        >
        </b-table>

        <div class="mx-2 mt-1 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ customerGrowthDataMeta.of }}個記錄中，正在顯示
                {{ customerGrowthDataMeta.from }} 至
                {{ customerGrowthDataMeta.to }}個記錄</span
              >
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="customerGrowthCurrentPage"
                :total-rows="totalCustomerGrowth"
                :per-page="customerGrowthPerPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>

    <div class="mt-3">
      <b-card>
        <div class="d-flex justify-content-end">
          <download-excel
            class="btn btn-primary mb-1"
            :name="`用戶數量分析-${date_from}-${date_to}.xls`"
            :fields="userTypeFields"
            :data="userTypeTableData"
          >
            導出Excel
          </download-excel>
        </div>
        <apexchart
          v-if="isInit"
          type="bar"
          height="350"
          :options="userTypeOptions"
          :series="user_type"
          :key="'UserType' + chartKey"
        ></apexchart>

        <b-table
          ref="refUserTypeTable"
          class="position-relative mt-2"
          :items="userTypeTableData"
          responsive
          :fields="userTypeTableColumns"
          show-empty
          empty-text="未找到匹配的記錄"
        >
          <!-- Column: Date -->
          <template #cell(Date)="data">
            {{ data.item.year }}年{{ data.item.month }}月
          </template>
        </b-table>
        <div class="mx-2 mt-1 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ userTypeDataMeta.of }}個記錄中，正在顯示
                {{ userTypeDataMeta.from }} 至
                {{ userTypeDataMeta.to }}個記錄</span
              >
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="userTypeCurrentPage"
                :total-rows="totalUserType"
                :per-page="userTypePerPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </section>
</template>
          
  <script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import { formatCurrency } from "@core/utils/filter";
import vSelect from "vue-select";
import axiosIns from "@/libs/axios";
import {
  ref,
  onMounted,
  watch,
  computed,
  onUnmounted,
} from "@vue/composition-api";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  data() {
    return {
      dateRange: [],
    };
  },
  watch: {
    dateRange: {
      handler() {
        [this.date_from, this.date_to] = this.dateRange;
        if (typeof this.date_from === "object") {
          this.date_from = this.getFormatedDate(this.date_from);
          this.date_to = this.getFormatedDate(this.date_to);
        }
      },
    },
  },
  created() {
    const last_year = new Date(
      new Date().setFullYear(new Date().getFullYear() - 1)
    );
    this.dateRange = [
      this.getFormatedDate(last_year),
      this.getFormatedDate(new Date()),
    ];
  },
  methods: {
    getFormatedDate(date) {
      const mm = date.getMonth() + 1; // getMonth() is zero-based
      const dd = date.getDate();

      return [
        date.getFullYear(),
        (mm > 9 ? "" : "0") + mm,
        (dd > 9 ? "" : "0") + dd,
      ].join("-");
    },
  },
  setup() {
    const loading = ref(false);
    // for chart series
    const monthly_sales = ref([
      {
        name: "",
        data: [],
      },
    ]);
    const daily_sales = ref([
      {
        name: "",
        data: [],
      },
    ]);
    const category_sales = ref([]);
    const customer_sales = ref([]);
    const customer_growth = ref([
      {
        name: "",
        data: [],
      },
    ]);
    const user_type = ref([
      {
        name: "",
        data: [],
      },
    ]);

    const date_from = ref(null);
    const date_to = ref(null);

    const chartKey = ref(0);

    // for chart Options
    const monthlySalesOptions = ref({
      chart: {
        height: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "straight",
      },
      title: {
        text: "月結財務分析",
        align: "left",
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [],
      },
    });
    const dailySalesOptions = ref({
      chart: {
        height: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "straight",
      },
      title: {
        text: "日結財務分析",
        align: "left",
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [],
      },
    });
    const categorySalesOptions = ref({
      chart: {
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "40%",
          // endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false,
      },
      title: {
        text: "服務及產品分析",
        align: "left",
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        title: {
          // text: '$ (thousands)'
        },
      },
      fill: {
        opacity: 1,
      },
    });
    const customerSalesOptions = ref({
      chart: {
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "40%",
          colors: {
            categories: ["#f00", "#0f0", "#00f"],
          },
          // endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false,
      },
      title: {
        text: "會員紀錄分析",
        align: "left",
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        title: {
          // text: '$ (thousands)'
        },
      },
      fill: {
        opacity: 1,
      },
    });
    const customerGrowthOptions = ref({
      chart: {
        height: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "straight",
      },
      title: {
        text: "會員數增長分析",
        align: "left",
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [],
      },
    });
    const userTypeOptions = ref({
      chart: {
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "40%",
          colors: {
            categories: ["#f00", "#0f0", "#00f"],
          },
          // endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false,
      },
      title: {
        text: "用戶數量分析",
        align: "left",
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        title: {
          // text: '$ (thousands)'
        },
      },
      fill: {
        opacity: 1,
      },
    });

    const monthlySalesTableData = ref(null);
    const monthlySalesTableData_original = ref(null);
    const monthlySalesTableColumns = [
      { key: "Date", label: "日期", sortable: true },
      { key: "total_amount", label: "總數", sortable: true },
      { key: "total_paid", label: "已付", sortable: true, formatter: formatCurrency },
      { key: "total_due", label: "欠款", sortable: true },
    ];
    // for excel
    const monthlySalesFields = ref({
      年份: `year`,
      月份: `month`,
      總數: "total_amount",
      已付: "total_paid",
      欠款: "total_due",
    });

    const dailySalesTableData = ref(null);
    const dailySalesTableData_original = ref(null);
    const dailySalesTableColumns = [
      { key: "date", label: "日期", sortable: true },
      { key: "total_amount", label: "總數", sortable: true },
      { key: "total_paid", label: "已付", sortable: true, formatter: formatCurrency },
      { key: "total_due", label: "欠款", sortable: true },
    ];
    // for excel
    const dailySalesFields = ref({
      日期: `date`,
      總數: "total_amount",
      已付: "total_paid",
      欠款: "total_due",
    });

    const categorySalesTableData = ref(null);
    const categorySalesTableData_original = ref(null);
    const categorySalesTableColumns = [
      { key: "Date", label: "日期", sortable: true },
      {
        key: "category_name",
        stickyColumn: true,
        label: "名稱",
        sortable: true,
      },
      { key: "total_category_sales", label: "銷售金額", sortable: true, formatter: formatCurrency },
      { key: "total_paid", label: "已付", sortable: true, formatter: formatCurrency },
      // { key: "total_due", label: "欠款", sortable: true },
    ];
    // for excel
    const categorySalesFields = ref({
      年份: `year`,
      月份: `month`,
      名稱: `category_name`,
      銷售金額: "total_category_sales",
      已付: "total_paid",
    });

    const customerSalesTableData = ref(null);
    const customerSalesTableData_original = ref(null);
    const customerSalesTableColumns = [
      { key: "Date", label: "日期", sortable: true },
      {
        key: "customer_name",
        stickyColumn: true,
        label: "姓名",
        sortable: true,
      },
      { key: "total_sales", label: "銷售金額", sortable: true, formatter: formatCurrency },
      { key: "total_paid", label: "已付", sortable: true, formatter: formatCurrency },
      { key: "total_due", label: "欠款", sortable: true },
    ];
    // for excel
    const customerSalesFields = ref({
      年份: `year`,
      月份: `month`,
      姓名: `customer_name`,
      銷售金額: "total_sales",
      已付: "total_paid",
      欠款: "total_due",
    });

    const customerGrowthTableData = ref(null);
    const customerGrowthTableData_original = ref(null);
    const customerGrowthTableColumns = [
      { key: "month_year", label: "日期", sortable: true },
      {
        key: "customer_count",
        stickyColumn: true,
        label: "客戶數",
        sortable: true,
      },
    ];
    // for excel
    const customerGrowthFields = ref({
      日期: `month_year`,
      客戶數: `customer_count`,
    });

    const userTypeTableData = ref(null);
    const userTypeTableData_original = ref(null);
    const userTypeTableColumns = [
      { key: "type", label: "用戶類型", sortable: true },
      {
        key: "user_count",
        stickyColumn: true,
        label: "數量",
        sortable: true,
      },
    ];
    // for excel
    const userTypeFields = ref({
      用戶類型: `type`,
      數量: `user_count`,
    });

    // for per page
    const refetchTbData = (meta, perPage, current, target, original) => {
      const min = Number(meta.value.from - 1);
      const max = Number(perPage.value * current.value - 1);

      target.value = original.value.filter(
        (ele, index) => index >= min && index <= max
      );
    };

    const refMonthlyTable = ref(null);
    const monthlyCurrentPage = ref(1);
    const monthlyPerPage = ref(10);
    const totalMonthly = ref(0);

    // showing count of per page item
    const monthlyDataMeta = computed(() => {
      const localItemsCount = refMonthlyTable.value
        ? refMonthlyTable.value.localItems.length
        : 0;
      return {
        from:
          monthlyPerPage.value * (monthlyCurrentPage.value - 1) +
          (localItemsCount ? 1 : 0),
        to:
          monthlyPerPage.value * (monthlyCurrentPage.value - 1) +
          localItemsCount,
        of: totalMonthly.value,
      };
    });

    const refDailyTable = ref(null);
    const dailyCurrentPage = ref(1);
    const dailyPerPage = ref(10);
    const totalDaily = ref(0);

    // showing count of per page item
    const dailyDataMeta = computed(() => {
      const localItemsCount = refDailyTable.value
        ? refDailyTable.value.localItems.length
        : 0;
      return {
        from:
          dailyPerPage.value * (dailyCurrentPage.value - 1) +
          (localItemsCount ? 1 : 0),
        to: dailyPerPage.value * (dailyCurrentPage.value - 1) + localItemsCount,
        of: totalDaily.value,
      };
    });

    const refCategoryTable = ref(null);
    const categoryCurrentPage = ref(1);
    const categoryPerPage = ref(10);
    const totalCategory = ref(0);

    // showing count of per page item
    const categoryDataMeta = computed(() => {
      const localItemsCount = refCategoryTable.value
        ? refCategoryTable.value.localItems.length
        : 0;
      return {
        from:
          categoryPerPage.value * (categoryCurrentPage.value - 1) +
          (localItemsCount ? 1 : 0),
        to:
          categoryPerPage.value * (categoryCurrentPage.value - 1) +
          localItemsCount,
        of: totalCategory.value,
      };
    });

    const refCustomerTable = ref(null);
    const customerCurrentPage = ref(1);
    const customerPerPage = ref(10);
    const totalCustomer = ref(0);

    // showing count of per page item
    const customerDataMeta = computed(() => {
      const localItemsCount = refCustomerTable.value
        ? refCustomerTable.value.localItems.length
        : 0;
      return {
        from:
          customerPerPage.value * (customerCurrentPage.value - 1) +
          (localItemsCount ? 1 : 0),
        to:
          customerPerPage.value * (customerCurrentPage.value - 1) +
          localItemsCount,
        of: totalCustomer.value,
      };
    });

    const refCustomerGrowthTable = ref(null);
    const customerGrowthCurrentPage = ref(1);
    const customerGrowthPerPage = ref(10);
    const totalCustomerGrowth = ref(0);

    // showing count of per page item
    const customerGrowthDataMeta = computed(() => {
      const localItemsCount = refCustomerGrowthTable.value
        ? refCustomerGrowthTable.value.localItems.length
        : 0;
      return {
        from:
          customerGrowthPerPage.value * (customerGrowthCurrentPage.value - 1) +
          (localItemsCount ? 1 : 0),
        to:
          customerGrowthPerPage.value * (customerGrowthCurrentPage.value - 1) +
          localItemsCount,
        of: totalCustomerGrowth.value,
      };
    });

    const refUserTypeTable = ref(null);
    const userTypeCurrentPage = ref(1);
    const userTypePerPage = ref(10);
    const totalUserType = ref(0);

    // showing count of per page item
    const userTypeDataMeta = computed(() => {
      const localItemsCount = refUserTypeTable.value
        ? refUserTypeTable.value.localItems.length
        : 0;
      return {
        from:
          userTypePerPage.value * (userTypeCurrentPage.value - 1) +
          (localItemsCount ? 1 : 0),
        to:
          userTypePerPage.value * (userTypeCurrentPage.value - 1) +
          localItemsCount,
        of: totalUserType.value,
      };
    });

    // for chart option - xaxis label
    const getYearMonthLabel = (target) => {
      return [
        ...new Set(
          target.map((ele) => {
            return ele.year + "年" + ele.month + "月";
          })
        ),
      ];
    };

    // handle Simple bar chart series
    const getSimpleBarChartSeries = (target, arr, key, amountKey) => {
      // Map each unique category name
      var newArr = new Set(arr.map((ele) => ele[key]));
      target.value = [];
      newArr.forEach((ele) => {
        // Initialize category object
        var Obj = {
          name: ele,
          data: [],
        };
        // Aggregate amounts for each category
        arr.forEach((item) => {
          if (item[key] === ele) {
            Obj.data.push(item[amountKey]);
          }
        });
        // Add to result
        target.value.push(Obj);
      });
    };

    // handle bar chart series
    const getBarChartSeries = (target, arr, key, amountKey) => {
      // 获取唯一分类
      var categories = new Set(arr.map((item) => item[key]));

      // 初始化目标数组
      target.value = [];

      categories.forEach((category) => {
        // 初始化分类对象
        var obj = {
          name: category,
          data: [],
        };

        // 获取月份范围
        var months = arr.map((item) => item.month).sort((a, b) => a - b);
        var minMonth = months[0];
        var maxMonth = months[months.length - 1];

        // 初始化data数组
        for (var i = minMonth; i <= maxMonth; i++) {
          obj.data.push(0);
        }

        // 累加数据
        arr.forEach((item) => {
          if (item[key] === category) {
            obj.data[item.month - minMonth] = item[amountKey] || 0;
          }
        });

        // 添加到结果
        target.value.push(obj);
      });
    };

    // v-if init true load chart
    const isInit = ref(false);
    const refetchData = () => {
      loading.value = true;
      axiosIns
        .get("/finance/invoices/analysis/", {
          params: {
            date_from: date_from.value,
            date_to: date_to.value,
          },
        })
        .then((response) => {
          loading.value = false;
          monthlySalesTableData.value = response.data.monthly_sales;
          dailySalesTableData.value = response.data.daily_sales;
          categorySalesTableData.value = response.data.category_sales;
          customerSalesTableData.value = response.data.customer_sales;
          customerGrowthTableData.value = response.data.customer_growth_data;
          userTypeTableData.value = response.data.user_type_data;

          monthlySalesTableData_original.value = response.data.monthly_sales;
          dailySalesTableData_original.value = response.data.daily_sales;
          categorySalesTableData_original.value = response.data.category_sales;
          customerSalesTableData_original.value = response.data.customer_sales;
          customerGrowthTableData_original.value =
            response.data.customer_growth_data;
          userTypeTableData_original.value = response.data.user_type_data;

          // x label
          monthlySalesOptions.value.xaxis.categories = getYearMonthLabel(
            response.data.monthly_sales
          );

          dailySalesOptions.value.xaxis.categories =
            response.data.daily_sales.map((ele) => {
              return ele.date;
            });

          categorySalesOptions.value.xaxis.categories = getYearMonthLabel(
            response.data.category_sales
          );

          customerSalesOptions.value.xaxis.categories = getYearMonthLabel(
            response.data.customer_sales
          );

          customerGrowthOptions.value.xaxis.categories =
            response.data.customer_growth_data.map((ele) => ele.month_year);

          userTypeOptions.value.xaxis.categories =
            response.data.user_type_data.map((ele) => ele.type);

          // series
          monthly_sales.value[0].data = response.data.monthly_sales.map(
            (ele) => {
              return ele.total_amount;
            }
          );
          daily_sales.value[0].data = response.data.daily_sales.map((ele) => {
            return ele.total_amount;
          });

          getBarChartSeries(
            category_sales,
            response.data.category_sales,
            "category_name",
            "total_category_sales"
          );
          console.log('category_sales',category_sales.value)

          getBarChartSeries(
            customer_sales,
            response.data.customer_sales,
            "customer_name",
            "total_sales"
          );

          customer_growth.value[0].data =
            response.data.customer_growth_data.map((ele) => {
              return ele.customer_count;
            });

            user_type.value[0].name = "用戶數"
            user_type.value[0].data = response.data.user_type_data.map((ele) => {
              return ele.user_count;
            });

          // total
          totalDaily.value = dailySalesTableData.value.length;
          totalMonthly.value = monthlySalesTableData.value.length;
          totalCategory.value = categorySalesTableData.value.length;
          totalCustomer.value = customerSalesTableData.value.length;
          totalCustomerGrowth.value = customerGrowthTableData.value.length;
          totalUserType.value = userTypeTableData.value.length;

          refetchTbData(
            monthlyDataMeta,
            monthlyPerPage,
            monthlyCurrentPage,
            monthlySalesTableData,
            monthlySalesTableData_original
          );
          refetchTbData(
            dailyDataMeta,
            dailyPerPage,
            dailyCurrentPage,
            dailySalesTableData,
            dailySalesTableData_original
          );
          refetchTbData(
            categoryDataMeta,
            categoryPerPage,
            categoryCurrentPage,
            categorySalesTableData,
            categorySalesTableData_original
          );
          refetchTbData(
            customerDataMeta,
            customerPerPage,
            customerCurrentPage,
            customerSalesTableData,
            customerSalesTableData_original
          );

          refetchTbData(
            customerGrowthDataMeta,
            customerGrowthPerPage,
            customerGrowthCurrentPage,
            customerGrowthTableData,
            customerGrowthTableData_original
          );

          refetchTbData(
            userTypeDataMeta,
            userTypePerPage,
            userTypeCurrentPage,
            userTypeTableData,
            userTypeTableData_original
          );

          isInit.value = true;
          chartKey.value += 1;
        })
        .catch((error) => {
          console.log(error);
          loading.value = false;
        });
    };

    watch(
      [
        date_from,
        date_to,
        monthlyCurrentPage,
        dailyCurrentPage,
        customerCurrentPage,
        categoryCurrentPage,
        customerGrowthCurrentPage,
        userTypeCurrentPage,
      ],
      () => {
        refetchData();
      }
    );

    onMounted(() => {
      // refetchData();
    });

    return {
      monthly_sales,
      daily_sales,
      category_sales,
      customer_sales,
      customer_growth,
      user_type,

      date_from,
      date_to,

      monthlySalesOptions,
      dailySalesOptions,
      categorySalesOptions,
      customerSalesOptions,
      customerGrowthOptions,
      userTypeOptions,

      refetchData,
      loading,
      isInit,
      chartKey,

      monthlySalesTableData,
      monthlySalesFields,
      monthlySalesTableColumns,

      dailySalesTableData,
      dailySalesFields,
      dailySalesTableColumns,

      categorySalesTableData,
      categorySalesFields,
      categorySalesTableColumns,

      customerSalesTableData,
      customerSalesFields,
      customerSalesTableColumns,

      customerGrowthTableData,
      customerGrowthFields,
      customerGrowthTableColumns,

      userTypeTableData,
      userTypeFields,
      userTypeTableColumns,

      refMonthlyTable,
      totalMonthly,
      monthlyDataMeta,
      monthlyPerPage,
      monthlyCurrentPage,

      refDailyTable,
      totalDaily,
      dailyDataMeta,
      dailyPerPage,
      dailyCurrentPage,

      refCategoryTable,
      totalCategory,
      categoryDataMeta,
      categoryPerPage,
      categoryCurrentPage,

      refCustomerTable,
      totalCustomer,
      customerDataMeta,
      customerPerPage,
      customerCurrentPage,

      refCustomerGrowthTable,
      totalCustomerGrowth,
      customerGrowthDataMeta,
      customerGrowthPerPage,
      customerGrowthCurrentPage,

      refUserTypeTable,
      totalUserType,
      userTypeDataMeta,
      userTypePerPage,
      userTypeCurrentPage,
    };
  },
};
</script>
          
<style lang="scss" scoped>
.apexcharts-toolbar {
  display: none;
}
.fixed_date_picker {
  position: fixed;
  top: 7.2rem;
  z-index: 2;
}
</style>
          
      <style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
</style>
          